/* eslint-disable no-shadow */
const state = {
	filterClassResponse: {
		min_price: 0,
		max_price: 1000
	},
	filter: [],
	filters: [],
	filterSelected: [],
	filterClass: [],
	filterId: null,
	priceRange: [0, 1000],
	keyWord: null,
	filterApplied: false,
	filterAppliedStatus: false,
	priceFilterApplied: false,
	showSortFilterLoader: false,
	sort: {
		sortOrder: 'ASC',
		sortMethod: 'Name'
	}
}

const getters = {
	getFilterClassResponse: state => state.filterClassResponse,
	getFilter: state => state.filter,
	getFilters: state => state.filters,
	getFilterSelected: state => state.filterSelected,
	getFilterClass: state => state.filterClass,
	getSelectedFilterValues: state => {
		const filterValues = []
		state.filters.forEach(fil => {
			if (fil.filterValues && fil.filterValues.length > 0) {
				fil.filterValues.forEach(f => {
					filterValues.push(f)
				})
			}
		})
		return filterValues
	},
	getFilterId: state => state.filterId,
	getPriceRange: state => state.priceRange,
	getKeyWord: state => state.keyWord,
	getSortData: state => state.sort,
	getFilterCount: state => state.filters.length,
	isFilterApplied: state => state.filterApplied,
	getFilterAppliedStatus: state => state.filterAppliedStatus,
	isPriceFilterApplied: state => state.priceFilterApplied,
	getshowSortFilterLoader: state => state.showSortFilterLoader
}

const mutations = {
	mutateSetFilterClassResponse: (state, payload) => {
		state.filterClassResponse = payload
	},
	mutateFilterSelected: (state, payload) => {
		state.filterSelected = payload
	},
	mutateSetFilters: (state, payload) => {
		state.filter = payload
	},
	mutateSetFilterClass: (state, payload) => {
		state.filterClass = payload
	},
	mutateUpdateFilters: (state, payload) => {
		state.filters = payload
	},
	mutateUpdatePriceRange: (state, payload) => {
		state.priceRange = payload
	},
	mutateUpdateKeyWord: (state, payload) => {
		state.keyWord = payload
	},
	mutateUpdateFilterId: (state, payload) => {
		state.filterId = payload
	},

	mutateEmptyFilters: state => {
		state.filters = []
		// state.filter = [];
		state.keyWord = null
	},
	mutateSort: (state, payload) => {
		state.sort = payload
	},
	mutateResetFilters: state => {
		const Filters = JSON.parse(JSON.stringify(state.filters))
		Filters.forEach((filter, key) => {
			state.filters[key].filterValues = []
		})
	},
	mutateUpdateFilterApplied: (state, payload) => {
		state.filterApplied = payload
	},
	mutateUpdateFilterAppliedStatus: (state, payload) => {
		state.filterAppliedStatus = payload
	},
	mutatePriceFilterApplied: (state, payload) => {
		state.priceFilterApplied = payload
	},
	mutateSortFilterLoader: (state, payload) => {
		state.showSortFilterLoader = payload
	}
}

const actions = {
	setFilterSelected: ({ commit }, payload) => {
		commit('mutateFilterSelected', payload)
	},
	setFilterClassResponse: ({ commit }, payload) => {
		commit('mutateSetFilterClassResponse', payload)
	},
	setFilter: ({ commit }, payload) => {
		commit('mutateSetFilters', payload)
	},
	setFilterClass: ({ commit }, payload) => {
		commit('mutateSetFilterClass', payload)
	},
	updateFilters: ({ commit }, payload) => {
		commit('mutateUpdateFilters', payload)
	},
	updatePriceRange: ({ commit }, payload) => {
		commit('mutateUpdatePriceRange', payload)
	},
	updateKeyWord: ({ commit }, payload) => {
		commit('mutateUpdateKeyWord', payload)
	},
	updateFilterId: ({ commit }, payload) => {
		commit('mutateUpdateFilterId', payload)
	},
	setSortData: ({ commit }, payload) => {
		commit('mutateSort', payload)
	},
	emptyFilters: ({ commit }) => {
		commit('mutateEmptyFilters')
	},
	resetFilters: ({ commit }) => {
		commit('mutateResetFilters')
	},
	updateFilterApplied: ({ commit }, payload) => {
		commit('mutateUpdateFilterApplied', payload)
	},
	updateFilterAppliedStatus: ({ commit }, payload) => {
		commit('mutateUpdateFilterAppliedStatus', payload)
	},
	setPriceFilterApplied: ({ commit }, payload) => {
		commit('mutatePriceFilterApplied', payload)
	},
	setSortFilterLoader: ({ commit }, payload) => {
		commit('mutateSortFilterLoader', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
